// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"300":"e5adf8c3","700":"c6f92922","952":"03cf3ebe"}[chunkId] + ".chunk.js";
};